<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="w-1/2">
          <div class="flex gap-4 items-center">
            <vs-input
              class="inputx mb-1 w-1/2"
              v-model="model.code"
              type="number"
              name="AccountCode"
              :label="$t('AccountCode')"
              v-validate="'required'"
            />
            <div class="mt-5 flex w-1/2">
              <span style="direction: ltr">{{ parentCode }} _</span>
            </div>
          </div>
          <span
            class="text-danger text-sm"
            v-show="errors.has('AccountCode')"
            >{{ errors.first("AccountCode") }}</span
          >
        </div>
        <div>
          <vs-input
            class="inputx mb-1 mt-1"
            v-model="model.title"
            name="AccountDetailTitle"
            :label="$t('AccountDetailTitle')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('AccountDetailTitle')"
            >{{ errors.first("AccountDetailTitle") }}</span
          >
        </div>
        <div>
          <vs-textarea
            rows="5"
            class="mt-4"
            name="Description"
            :label="$t('Description')"
            v-model="model.description"
          />
        </div>

        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="
            !model.code ||
            !model.title
              ? true
              : false
          "
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    AccountCode: {
      required: "لطفا کد حساب را وارد نمایید.",
    },

    AccountDetailTitle: {
      required: "لطفا عنوان حساب تفضیلی را وارد نمایید.",
    },

  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    parentType: {
      default: 0,
    },
    parentCode: {
      default: 0,
    },
  },
  data() {
    return {
      AccountTitle: "",
      popupTitle: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createAccount: "detailAccount/create",
    }),
    // checkValidation(){
    //   if(!model.expireClock || !model.startClock || !model.accountReferenceType || !model.accountReferenceId || !Model.title){
    //     return true
    //   }
    //   else{
    //     return false
    //   }
    // },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model.parentAccountId = this.parentType;
          this.createAccount(this.model).then(() => {
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditAccount";
        else this.popupTitle = "CreateNewDetailAccount";
      }
      this.$validator.reset();
    },
  },
};
</script>
